import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Input } from 'reactstrap';
import { USER_ACCOUNT_TYPES } from '../../../constants/userDefs';

export const TableHeader = ({ titleId, sector, setSector }) => {
  const { formatMessage } = useIntl();

  return (
    <div className="rt-thead hok-custom-table-header">
      <div className="rt-tr">
        <div className="rt-th">
          <div className="hok-title-wrapper">
            <h2>
              <FormattedMessage id={titleId} />
            </h2>
          </div>
          <div className="hok-input-wrapper">
            <Input
              type="select"
              value={sector}
              onChange={event => {
                setSector(event.target.value);
              }}>
              <option value="">{formatMessage({ id: `adminUsersListPage.filter.all` })}</option>
              {USER_ACCOUNT_TYPES.map(type => (
                <option key={type.name} value={type.name}>
                  {formatMessage({ id: `adminUsersListPage.filter.${type.name}` })}
                </option>
              ))}
            </Input>
          </div>
        </div>
      </div>
    </div>
  );
};
